
  import Vue from 'vue';
  import {mapState} from 'vuex';
  import {library} from '@/models/library';

  export default Vue.extend({
    name: 'Favorite',
    components: {
      TrackList: () => import ('@/components/TrackList.vue'),
    },
    data() {
      return {
        tracks: library.loadFavoriteTracks(),
      }
    },
    computed: {
      ...mapState(['searchQuery', 'favoriteTracks']),
    },
  });
